import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { GridColumnDef } from 'ng2-app/models/businesses/GridColumnDef.model';
import { findIndex } from 'lodash';
import { LocalStorageService } from 'app/services/local-storage/local-storage.service';

const KEY = 'pipelineColumnData';

@Injectable({
  providedIn: 'root'
})
export class ColumnDataService {

  private colObjectData: GridColumnDef[];

  constructor(private localStorageService: LocalStorageService) {
    this.colObjectData = JSON.parse(this.localStorageService.localStorage.getItem(KEY) || '[{}]') as GridColumnDef[];
  }

  getColumnDataByPath(path: string = window.location.pathname): GridColumnDef {
    const listData = this.colObjectData.find(col => col.path = path);
    return listData || {
      path,
      active: '',
      definitions: [{}] as ColDef[],
    };
  }

  setColumn(column: GridColumnDef): GridColumnDef {
    const index = findIndex(this.colObjectData, column);

    if (index === -1) {
      this.colObjectData.push(column);
    } else {
      this.colObjectData.splice(index, 1, column);
    }

    this.setColumnData(this.colObjectData);
    return column;
  }

  setColumnData(columns: GridColumnDef[]): GridColumnDef[] {
    this.localStorageService.localStorage.setItem(KEY, JSON.stringify(columns));
    return columns;
  }
}
